import AlumneCasal from "../../model/inscripcions/AlumneCasal";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcioInfant = async ( infant: AlumneCasal , id_inscripcio : string, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id_inscripcio}/infants`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(infant)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
